// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import _ from 'lodash';
import React, { ComponentPropsWithoutRef, useContext } from 'react';
import CommonContext from '../../contexts/CommonContext';
import Level from '../common/Level';
import { S } from './styles';

interface LevelMeterProps extends ComponentPropsWithoutRef<'div'> {
  levelId: number;
  showName?: boolean;
  namePosition?:'left'
}

const LevelMeter = (props: LevelMeterProps): JSX.Element => {
  const {
    levelId,
    showName,
    namePosition=undefined,
    ...otherProps
  } = props;

  const { levels } = useContext(CommonContext);
  const level = parseInt((levels.find(level => level.id === levelId)?.level || '100'), 10) / 100;

  return (
    <S.LevelContainer {...otherProps}>
      {
        showName && (namePosition !== 'left') && (
          <S.LevelName><Level id={levelId} /></S.LevelName>
        )
      }
      {
        levelId !== 0 && _.times(level, (index) => <S.LevelPillOrange key={index} />)
      }
      {
        levelId === 0 ? _.times(4, (index) => <S.LevelPill key={index} />) : _.times(4 - level, (index) => <S.LevelPill key={index} />)
      }
      {
        showName && (namePosition === 'left') && (
          <S.LevelName namePosition={namePosition}><Level id={levelId} /></S.LevelName>
        )
      }
    </S.LevelContainer>
  );
}

export { LevelMeter as default };
